// extracted by mini-css-extract-plugin
module.exports = {"inputButtonContainer":"NewSensorModal_inputButtonContainer__1Nejy","inputContainer":"NewSensorModal_inputContainer__1OW8D"};